import Config from "../../../core/config/Config";
import NGTConfigKey from "../../base/NGTConfigKey";
import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import RevisionToolGateway from "./RevisionToolGateway";

export default class InitRevisionToolTask extends Task {

    /**
     * @param {Config} config 
     * @param {createjs.Stage} stage 
     * @param {RevisionToolGateway} revisionToolGateway 
     */
    constructor(config, stage, revisionToolGateway) {
        super();

        this.execute = (callback, progressCallback) => {
            if (window.parent.ranj) {
                ranj.revisionAPI = parent.ranj.revisionAPI;
            }
            var appID = config.getValue(Config.APPID);
            var buildID = config.getValue(Config.BUILDID);
            revisionToolGateway.setup(stage, appID, buildID, config.getValue("revisionTool.useContentPreviewer"));
            //Task complete:
            callback(this);
        }
    }


}